import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminCustomFields } from '@/api/(admin)/custom-information-fields';
import type { AdminCustomField } from '@/api/(admin)/custom-information-fields/types';
import type { CustomFieldsQueryInput } from '../-types';
import {
  buildCustomFieldsQs,
  toCustomFieldsParams,
} from '../-utils/listParams';

/** Prefix for every custom-information-fields cache entry — what a write invalidates. */
export const adminCustomFieldsQueryKey = [
  'admin',
  'custom-information-fields',
] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminCustomFieldsQueryOptions(input: CustomFieldsQueryInput) {
  const params = toCustomFieldsParams(input);
  return queryOptions({
    queryKey: [...adminCustomFieldsQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminCustomFields(buildCustomFieldsQs(params)),
  });
}

export function useAdminCustomFields(input: CustomFieldsQueryInput) {
  const query = useQuery(adminCustomFieldsQueryOptions(input));
  const rows: AdminCustomField[] = query.data?.data ?? [];
  return {
    ...query,
    rows,
    totalCount: query.data?.metadata.pagination.total ?? 0,
  };
}
